import styled, { css } from 'styled-components';
import TOKENS from '@nokia-csf-uxr/freeform-design-tokens';
import { DEEP_BORDER_BOX } from 'common';
import { XXXL, XL, L, M, S, XS } from './breakpoints';

const { SPACING, SHADOW_SPREAD, RADIUS } = TOKENS;
const SPACING_36 = `${parseFloat(SPACING.SPACING_12, 10) + parseFloat(SPACING.SPACING_24, 10)}rem`; // Perhaps this needs to be in TOKEN library
const SPACING_1 = '0.0625rem';
const TRANSITION_BEZIER = TOKENS.TRANSITION.TRANSITION_STANDARD;
const TILE_SIZE = '10.625rem'; // 170px

const BREAKPOINT_XXXL = `@media only screen and (min-width: ${XXXL.MIN}px)`;

const BREAKPOINT_XL = `@media only screen and (min-width: ${XL.MIN}px) and (max-width: ${XL.MAX}px)`;

const BREAKPOINT_L = `@media only screen and (min-width: ${L.MIN}px) and (max-width: ${L.MAX}px)`;
const BREAKPOINT_M = `@media only screen and (min-width: ${M.MIN}px) and (max-width: ${M.MAX}px)`;
const BREAKPOINT_S = `@media only screen and (min-width: ${S.MIN}px) and (max-width: ${S.MAX}px)`;
const BREAKPOINT_XS = `@media only screen and (min-width: ${XS.MIN}px) and (max-width: ${XS.MAX}px)`;
/* XS to S */
const BREAKPOINT_XS_S = `@media only screen and (min-width: ${XS.MIN}px) and (max-width: ${S.MAX}px)`;
/* XS to L */
const BREAKPOINT_XS_L = `@media only screen and (min-width: ${XS.MIN}px) and (max-width: ${L.MAX}px)`;

const LaunchPad = styled.div`
  ${DEEP_BORDER_BOX}
  position: relative;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  ${BREAKPOINT_XXXL} {
    background: ${props => props.theme.background};
  }
`;

const LaunchPadInner = styled.div`
  position: relative;
  ${BREAKPOINT_XXXL} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 120rem; // 1920px
    height: 67.5rem; //1080px
    box-shadow: rgba(0, 0, 0, 0.12) 0px 0px ${SPACING_1} 0px, rgba(0, 0, 0, 0.24) 0px ${SPACING_1} ${SPACING_1} 0px;
  }
  display: flex;
  flex-direction: column;

  ${({ $rtl }) =>
    $rtl &&
    css`
      direction: rtl;
    `};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background: ${props => props.theme.innerBackground};
`;

const LaunchPadHeaderInner = styled.div`
  display: flex;
  width: 100%;
`;

const LaunchPadHeader = styled.div`
  padding: ${SPACING.SPACING_64};
  padding-bottom: 0;
  display: flex;
  align-items: center;
  [class^='styles__UserAccountSummaryContainer-'] {
    ${({ $rtl }) => ($rtl ? 'margin-right: auto;' : 'margin-left: auto;')}
  }
  ${BREAKPOINT_XS_L} {
    padding: ${SPACING.SPACING_48};
    padding-bottom: 0;
  }
  ${BREAKPOINT_XS_S} {
    padding: ${SPACING.SPACING_16};
    padding-bottom: 0;
  }

  /** Adjustments for UAS button */
  [class^='styles__UserAccountSummaryButton-'] {
    [class^='styles__ContentWrapper-'] {
      ${({ $rtl }) => ($rtl ? 'padding-left: 0;' : 'padding-right: 0;')}
    }
  }
`;

const LaunchPadFooter = styled.div`
  padding: ${SPACING.SPACING_64};
  display: flex;
  align-items: center;
  ${BREAKPOINT_L} {
    padding: ${SPACING.SPACING_48};
  }
  ${BREAKPOINT_XS_S} {
    padding: ${SPACING.SPACING_16};
  }
`;

const LaunchPadContent = styled.div`
  display: flex;
  flex-grow: 1;
  /* align-items: center; */
  justify-content: flex-start;
  flex-direction: column;
  margin-top: ${SPACING.SPACING_48};
  ${BREAKPOINT_M} {
    margin-top: calc(${SPACING.SPACING_48} + ${SPACING.SPACING_48});
  }
  ${BREAKPOINT_XS_S} {
    margin-top: ${SPACING.SPACING_24};
  }
`;
const LaunchPadContentInner = styled.div`
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(${XXXL.TILES}, minmax(${TILE_SIZE}, ${TILE_SIZE}));
  gap: ${SPACING.SPACING_24};
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-bottom: 5px;
  ${BREAKPOINT_XL} {
    grid-template-columns: repeat(${XL.TILES}, minmax(${TILE_SIZE}, ${TILE_SIZE}));
  }
  ${BREAKPOINT_L} {
    grid-template-columns: repeat(${L.TILES}, minmax(${TILE_SIZE}, ${TILE_SIZE}));
  }
  ${BREAKPOINT_M} {
    grid-template-columns: repeat(${M.TILES}, minmax(${TILE_SIZE}, ${TILE_SIZE}));
  }
  ${BREAKPOINT_S} {
    grid-template-columns: repeat(${S.TILES}, minmax(${TILE_SIZE}, ${TILE_SIZE}));
  }
  ${BREAKPOINT_XS} {
    grid-template-columns: repeat(${XS.TILES}, minmax(${TILE_SIZE}, ${TILE_SIZE}));
  }
  ${BREAKPOINT_XS_S} {
    grid-row-gap: ${SPACING.SPACING_12};
    grid-column-gap: ${SPACING.SPACING_16};
  }
`;

const LaunchPadProductName = styled.div`
  margin: 0 ${SPACING_36};
  h2 {
    line-height: inherit !important; // so it's flush with bottom;
    font-weight: ${TOKENS.FONT_WEIGHT.FONT_WEIGHT_THIN};
  }
  ${BREAKPOINT_M} {
    transform: translateY(calc(100% + ${SPACING.SPACING_24}));
    margin: 0;
    position: absolute;
    left: ${SPACING.SPACING_48};
    ${props =>
    props.$rtl &&
      css`
        left: inherit;
        right: ${SPACING.SPACING_48};
      `};
  }

  ${BREAKPOINT_XS_S} {
    display: none;
  }
`;

const LaunchPadTile = styled.div`
  background-color: ${props => props.theme.lightBackgroundColor};
  // elevation 2
  box-shadow: 0 ${SHADOW_SPREAD.SHADOW_SPREAD_2} ${SHADOW_SPREAD.SHADOW_SPREAD_2} 0 ${props => props.theme.shadowColorOne},
    0 0 ${SHADOW_SPREAD.SHADOW_SPREAD_2} 0 ${props => props.theme.shadowColorTwo};
  border-radius: ${SPACING.SPACING_2};
  width: 10.625rem;
  height: 9.5rem;
  padding: ${SPACING.SPACING_24};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${({ $disableAnimation }) => !$disableAnimation &&
  css`
    transition: box-shadow 0.3s ${TRANSITION_BEZIER}, border 0.3s ${TRANSITION_BEZIER};
  `}
  border: ${RADIUS.RADIUS_2} solid transparent;
  word-break: break-word;
  cursor: pointer;
  &:hover {
    // elevation 4
    box-shadow: 0 ${SHADOW_SPREAD.SHADOW_SPREAD_8} ${SHADOW_SPREAD.SHADOW_SPREAD_8} 0 ${props => props.theme.hover.shadowColorOne},
      0 0 ${SHADOW_SPREAD.SHADOW_SPREAD_8} 0 ${props => props.theme.hover.shadowColorTwo};
  }
  &:focus {
    outline: 0;
    border: ${RADIUS.RADIUS_2} solid ${props => props.theme.focus.border};
  }
`;

const LaunchPadTileTitle = styled.div`
  text-align: center;
`;
const LaunchPadTileSubtitle = styled.div`
  padding: ${SPACING.SPACING_8} 0;
`;

const LaunchPadTileIcon = styled.div`
  flex-grow: 1;
`;

export default {
  LaunchPad,
  LaunchPadInner,
  LaunchPadContent,
  LaunchPadContentInner,
  LaunchPadProductName,
  LaunchPadTile,
  LaunchPadTileTitle,
  LaunchPadTileSubtitle,
  LaunchPadTileIcon,
  LaunchPadHeader,
  LaunchPadHeaderInner,
  LaunchPadFooter
};
